import { IDocumentDataDragParameter } from "../../../components/dragging";

export interface IDocumentDataDraggable {
  toDocumentDataDragParameter(): IDocumentDataDragParameter;
  setDroppedDocumentData(text: string, param: IDocumentDataDragParameter): void;
}

export function instanceOfIDocumentDataDraggable(instance: any): instance is IDocumentDataDraggable {
  return instance
    && (instance.setDroppedDocumentData !== undefined)
    && (instance.toDocumentDataDragParameter !== undefined);
}
